import 'slick-carousel';

// Variable Declaration
const $carousel = $('#inc-carousel');
const $control = $('.inc-carousel');

// Initialization carousel
$carousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  arrows: false,
  prevArrow: '<button class="arrow arrow-prev"></button>',
  nextArrow: '<button class="arrow arrow-next"></button>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        variableWidth: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 1199,
      settings: {
        arrows: true,
        centerMode: true,
        variableWidth: true
      }
    }
  ]
});
